import { reactive } from 'vue'

// --- Confirm Dialog ---

interface ConfirmState {
  visible: boolean
  title: string
  message: string
  confirmText: string
  cancelText: string
  resolve: ((value: boolean) => void) | null
}

const confirmState = reactive<ConfirmState>({
  visible: false,
  title: '提示',
  message: '',
  confirmText: '确定',
  cancelText: '取消',
  resolve: null,
})

function confirm(
  message: string,
  options?: { title?: string; confirmText?: string; cancelText?: string }
): Promise<boolean> {
  return new Promise((resolve) => {
    confirmState.message = message
    confirmState.title = options?.title ?? '提示'
    confirmState.confirmText = options?.confirmText ?? '确定'
    confirmState.cancelText = options?.cancelText ?? '取消'
    confirmState.resolve = resolve
    confirmState.visible = true
  })
}

function handleConfirm(): void {
  confirmState.visible = false
  confirmState.resolve?.(true)
  confirmState.resolve = null
}

function handleCancel(): void {
  confirmState.visible = false
  confirmState.resolve?.(false)
  confirmState.resolve = null
}

// --- Quota Modal ---

const quotaModalVisible = reactive({ value: false })

function showQuotaModal(): void {
  quotaModalVisible.value = true
}

function closeQuotaModal(): void {
  quotaModalVisible.value = false
}

// --- Toast Message ---

interface ToastItem {
  id: number
  message: string
  type: 'info' | 'success' | 'warning' | 'error'
}

let toastId = 0
const toasts = reactive<ToastItem[]>([])

function toast(message: string, type: ToastItem['type'] = 'info'): void {
  const id = ++toastId
  toasts.push({ id, message, type })
  setTimeout(() => {
    const idx = toasts.findIndex((t) => t.id === id)
    if (idx >= 0) toasts.splice(idx, 1)
  }, 3500)
}

toast.success = (msg: string) => toast(msg, 'success')
toast.warning = (msg: string) => toast(msg, 'warning')
toast.error = (msg: string) => toast(msg, 'error')
toast.info = (msg: string) => toast(msg, 'info')

export function useModal() {
  return {
    confirmState,
    confirm,
    handleConfirm,
    handleCancel,
    quotaModalVisible,
    showQuotaModal,
    closeQuotaModal,
    toasts,
    toast,
  }
}
